import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class ItemRevision extends Model<Schemas['itemRevisions'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    get plagiarismCheckedAtDate() {
        return nullableDate(this.plagiarismCheckedAt);
    }

    get isPublished(): boolean {
        return this.item?.status === 'accepted' && this === this.item.activeRevision;
    }
}
